import Smartphones from 'Reports/views/FinancialReport/FinancialReportsView/containers/Smartphones'
import Tablets from 'Reports/views/FinancialReport/FinancialReportsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const FinancialReportsView = getCurrentDeviceView(Smartphones, Tablets)

export default FinancialReportsView
